import { Box, Divider, IconButton, Stack, Tooltip, Typography, styled, tooltipClasses } from '@mui/material'
import type { FC, PropsWithChildren, ReactNode } from 'react'
import type { SxProps, Theme, TooltipProps, TypographyProps } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'

export interface IHelpTooltipProps {
  title: string
  small?: boolean
  sxIcon?: SxProps<Theme>
}

export const HelpTooltip: FC<PropsWithChildren<IHelpTooltipProps>> = (props) => (
  <TooltipStyled
    arrow
    placement='bottom'
    title={
      <Stack sx={{ gap: '6px', py: '6px', minWidth: '200px', maxWidth: '400px ' }}>
        <TooltipHeaderText>{props.title}</TooltipHeaderText>
        <Divider />
        <Box sx={{ p: '6px 12px' }}>{props.children}</Box>
      </Stack>
    }
  >
    <Box sx={{ cursor: 'default', ...props.sxIcon }}>
      <IconButton size='small'>
        <HelpOutlineIcon fontSize={props.small ? 'small' : 'medium'} sx={{ color: 'rgb(25,103,210)' }} />
      </IconButton>
    </Box>
  </TooltipStyled>
)

export default HelpTooltip

export interface IHelpTooltipWrapProps {
  content: ReactNode
  title: string
  children: React.ReactNode
}

export const HelpTooltipWrap: FC<IHelpTooltipWrapProps> = (props) => (
  <TooltipStyled
    arrow
    placement='bottom'
    title={
      <Stack sx={{ gap: '6px', py: '6px', minWidth: '200px', maxWidth: '400px ' }}>
        <TooltipHeaderText>{props.title}</TooltipHeaderText>
        <Divider />
        <Box sx={{ p: '6px 12px' }}>{props.content}</Box>
      </Stack>
    }
  >
    <Box sx={{ cursor: 'default' }}>{props.children}</Box>
  </TooltipStyled>
)

const TooltipHeaderText = styled((props: TypographyProps) => <Typography variant='subtitle1' {...props} />)({
  color: '#0095ff',
  fontWeight: 700,
  padding: '0 10px'
})

const TooltipStyled = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    maxWidth: 500,
    minHeight: 120,
    fontSize: theme.typography.pxToRem(12),
    borderRadius: '8px',
    boxShadow: 'rgba(0, 0, 0, 0.08) 0px 6px 30px'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.background.paper
  }
}))
